/**
 * Per-device preferences for the tennis scoring pad. Stored in localStorage
 * like the drill alert settings — how fast the scorer taps is a personal,
 * device-level habit, not team data.
 */

export interface QuickTagAutoSave {
  enabled: boolean;
  seconds: number;
}

export const AUTO_SAVE_SECONDS_OPTIONS = [3, 5, 8, 10, 15] as const;

const DEFAULT_AUTO_SAVE: QuickTagAutoSave = { enabled: true, seconds: 5 };

const ENABLED_KEY = 'hustli_tennis_autosave_enabled';
const SECONDS_KEY = 'hustli_tennis_autosave_seconds';

export function loadQuickTagAutoSave(): QuickTagAutoSave {
  try {
    const enabled = window.localStorage.getItem(ENABLED_KEY);
    const seconds = Number(window.localStorage.getItem(SECONDS_KEY));
    return {
      enabled: enabled == null ? DEFAULT_AUTO_SAVE.enabled : enabled === 'true',
      seconds: (AUTO_SAVE_SECONDS_OPTIONS as readonly number[]).includes(seconds) ? seconds : DEFAULT_AUTO_SAVE.seconds,
    };
  } catch {
    return DEFAULT_AUTO_SAVE;
  }
}

export function saveQuickTagAutoSave(value: QuickTagAutoSave): void {
  try {
    window.localStorage.setItem(ENABLED_KEY, String(value.enabled));
    window.localStorage.setItem(SECONDS_KEY, String(value.seconds));
  } catch {
    // Storage unavailable (private browsing) — the setting just won't persist.
  }
}
